// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"419":"3eff8da7","534":"34cb2305","560":"66357d77"}[chunkId] + ".chunk.js";
};